import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { Link } from "react-router-dom";
import giftimage from "../../../assets/giftimage.png";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrdersOfUser } from "../../../redux/action/order";
import api from "../../../utils/api";
const ITEMS_PER_PAGE = 5; 
const MAX_VISIBLE_PAGES = 3;

const UserLogs = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1); // Start on page 1
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  const totalPages = Math.ceil(data?.length / ITEMS_PER_PAGE); // Calculate total pages

  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const response = await api.get(`/cash-back`);
        const filtered = response?.data?.results[0]?.cashbackRequests.filter(
          (order) => order?.userId === user?._id
        );
        const reversedRequests = filtered?.slice().reverse(); 
        setData(reversedRequests);
        console.log(reversedRequests);
        
      } catch (error) {
        console.error("Error fetching points:", error);
      }
    };

    fetchPoints();
  }, [user?._id]);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const paginatedData = data.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const getPaginationRange = () => {
    const range = [];
    let start = Math.max(1, page - Math.floor(MAX_VISIBLE_PAGES / 2));
    let end = Math.min(totalPages, start + MAX_VISIBLE_PAGES - 1);

    if (end - start + 1 < MAX_VISIBLE_PAGES) {
      start = Math.max(1, end - MAX_VISIBLE_PAGES + 1);
    }

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    if (end < totalPages) {
      range.push("...");
      range.push(totalPages);
    }

    return range;
  };

  // Paginated data
  
  const calculateRemainingTime = (estimatedTimeAt) => {
    // Convert estimatedTimeAt to local date
    const estimatedDate = new Date(estimatedTimeAt); 
    const currentDate = new Date(); // Local system timezone
  
    const estimatedTime = estimatedDate?.getTime(); // Time in milliseconds
    const currentTime = currentDate?.getTime();     // Current time in milliseconds
  
    const diffInMs = estimatedTime - currentTime;
  
    // Check if time is already passed
    if (diffInMs < 0) {
        return "pending";
    }
  
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor((diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffInMinutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  
    let remainingTime = "";
  
    if (diffInDays > 0) {
        remainingTime += `${diffInDays} day${diffInDays > 1 ? "s" : ""} `;
    }
  
    if (diffInHours > 0) {
        remainingTime += `${diffInHours} hour${diffInHours > 1 ? "s" : ""} `;
    }
  
    if (diffInMinutes > 0) {
        remainingTime += `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""}`;
    }
  
    return remainingTime.trim();
  };
  // Example usage:
  // const result = order?.estimatedTimeAt ? convertToHMS(order.estimatedTimeAt) : null;

  // console.log(result); 
  useEffect(() => {
    setPage(1);
  }, [data]);
  return (
    <>
      <div className="w-full mx-auto mt-6">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-[#AF313D] text-white uppercase md:font-bold text-[7.19px] sm:text-[7.19px] md:text-[13px] lg:text-[20px]">
              <th className="px-2 body py-2 md:px-4 text-center md:py-3">
                Order ID
              </th>
              <th className="px-2 body py-2 md:px-4 text-center md:py-3">
                Points
              </th>
              <th className="px-2 body py-2 md:px-4 text-center md:py-3">
              estimated Time
              </th>
              <th className="px-2 body py-2 md:px-4 text-center md:py-3">
                Cashback Status
              </th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((order) => (
              <tr
                key={order._id}
                className="bg-white border-b border-[#ddd] hover:bg-gray-100 text-[10.57px] sm:text-[10.57px] md:text-[15px] lg:text-[18px]"
              >
                <td className="px-2 py-2 md:px-4 md:py-3 text-center body text-gray-700">
                  {order.orderId?.slice(-6)}
                </td>
                <td className="px-2 py-2 md:px-4 md:py-3 text-center body text-gray-700">
                  {order.points}
                </td>
                <td className="px-2 py-2 md:px-4 md:py-3 text-center body text-gray-700">
                  {order?.status === 'processed' ? "-- --- --": (
                    <>
                    {calculateRemainingTime(order?.estimatedTimeAt) }
                    </>
                  )}
                  
                </td>
                <td className="px-2 py-2 md:px-4 md:py-3 text-center body text-gray-700">
                  <span
                    className={`${
                      order.status === "pending"
                        ? "text-yellow-400 bg-[#f1e4c0bd]"
                        : "text-green-500 bg-[#a2eeaea6]"
                    } py-1 px-3 rounded-md font-medium`}
                  >
                    {order?.status === 'failed'? "pending": order?.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Section */}
      <div className="flex justify-end px-6 mb-5 items-center gap-2 mt-6">
        <button onClick={() => handlePageChange(page - 1)} disabled={page === 1} className={`${page === 1 ? "text-gray-400 cursor-not-allowed" : "text-[#C97C2A]"}`}>
          &laquo;
        </button>

        {getPaginationRange().map((pageNumber, index) => (
          <button
            key={index}
            onClick={() => typeof pageNumber === 'number' && handlePageChange(pageNumber)}
            className={`px-2 py-1 text-sm rounded ${page === pageNumber ? "bg-[#C97C2A] text-white" : "text-[#C97C2A]"}`}
          >
            {pageNumber}
          </button>
        ))}

        <button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages} className={`${page === totalPages ? "text-gray-400 cursor-not-allowed" : "text-[#C97C2A]"}`}>
          &raquo;
        </button>
      </div>
    </>
  );
};

export default UserLogs;